module.exports = __webpack_public_path__ + "img/PDM-SU.2ddd32e9.png";